<template>
  <v-app class="tw-py-10">
    <v-main>
      <v-card class="tw-rounded-xl tw-mx-auto" max-width="1080">
        <div class="tw-container tw-mx-auto text-center tw-py-7">
          <router-link to="/">
            <img
              alt="ภาษีเจริญ"
              class="tw-mx-auto tw-w-36"
              src="/images/logo_phasi_charoen.svg"
            />
          </router-link>
          <!--       
        <div>
          <h1 class="tw-text-sm md:tw-text-2xl tw-font-bold">{{ this.headerText }}</h1>
          <p class="tw-text-sm md:text-md tw-mt-2">{{ this.headerSubText }}</p>
        </div>
         -->
        </div>
        <v-container>
          <template v-if="!isSubmit && !isLoading">
            <div class="tw-py-4">
              <v-sheet
                class="tw-border tw-px-4 bg-gray-800 tw-rounded-xl"
                color="#f8f8f8"
              >
                <p class="tw-pt-4 tw-font-bold text-center">รายละเอียดการขาย</p>
                <div class="tw-max-w-xl tw-mx-auto">
                  <div class="s-table">
                    <div>
                      <span>ชื่อร้าน:</span>
                      <span>{{ invoiceInfo?.companyName }}</span>
                    </div>
                    <div>
                      <span>เลขที่ใบกำกับภาษีอย่างย่อ / ABB Receipt:</span>
                      <span>{{ invoiceInfo?.docId }}</span>
                    </div>
                    <div>
                      <span>จำนวนเงินรวมทั้งสิ้น / GRAND TOTAL:</span>
                      <span>{{ formatTwoDecimal(invoiceInfo?.amount) }} บาท</span>
                    </div>
                  </div>
                </div>
              </v-sheet>
            </div>

            <h3 class="tw-text-lg tw-font-bold tw-pt-4 tw-pb-3 tw-pl-1">
              กรุณากรอกข้อมูลเพิ่มเติมเพื่อออกเอกสารใบกำกับเต็มรูป (Tax Invoice)
            </h3>
            <div id="tax-info-form" class="tw-py-4">
              <v-form ref="taxForm">
                <v-row>
                  <v-col class="tw-py-0" cols="12" lg="6" sm="12">
                    <v-text-field
                      v-model="customerData.name"
                      :rules="[(v) => !!v || 'กรุณากรอกชื่อ']"
                      label="ชื่อบริษัท (Company Name) / ชื่อ-สกุล (First Name - Last Name)"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col class="tw-py-0" cols="12" lg="6" sm="12">
                    <v-text-field
                      v-model="customerData.taxId"
                      :rules="[(v) => !!v || 'กรุณากรอกเลขประจำตัวผู้เสียภาษี']"
                      label="เลขประจำตัวผู้เสียภาษี (TAX ID) / National ID Card "
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      v-model="customerData.address.address1"
                      :rules="[(v) => !!v || 'กรุณากรอกที่อยู่']"
                      label="ที่อยู่ (Address) 1"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-text-field
                      v-model="customerData.address.address2"
                      label="ที่อยู่ (Address) 2"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div ref="zipAddress">
                  <v-row>
                    <v-col
                      class="material-textfield tw-py-0"
                      cols="12"
                      lg="6"
                      sm="12"
                    >
                      <ThailandAutoComplete
                        v-model="customerData.address.block"
                        label="แขวง/ตำบล (Block) "
                        placeholder=""
                        type="district"
                        @select="select"
                      />
                    </v-col>
                    <v-col
                      class="tw-py-0 material-textfield"
                      cols="12"
                      lg="6"
                      sm="12"
                    >
                      <ThailandAutoComplete
                        v-model="customerData.address.city"
                        label="เขต/อำเภอ (City) "
                        placeholder=""
                        type="amphoe"
                        @select="select"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      class="material-textfield tw-py-0"
                      cols="12"
                      lg="6"
                      sm="12"
                    >
                      <ThailandAutoComplete
                        v-model="customerData.address.county"
                        label="จังหวัด (County)"
                        placeholder=""
                        type="province"
                        @select="select"
                      />
                    </v-col>
                    <v-col
                      class="material-textfield tw-py-0"
                      cols="12"
                      lg="6"
                      sm="12"
                    >
                      <ThailandAutoComplete
                        v-model="customerData.address.zipCode"
                        label="รหัสไปรษณีย์ (Zip Code) *"
                        placeholder=""
                        type="zipcode"
                        @select="select"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <h2 v-if="!isAddressValid" class="input-address-error">
                        ที่อยู่ และ รหัสไปรษณีย์ ไม่ถูกต้อง
                      </h2>
                    </v-col>
                  </v-row>
                </div>
                <div class="submit-btn-wrapper">
                  <v-btn
                    block
                    class="btn-form tw-mt-4"
                    color="success"
                    elevation="0"
                    x-large
                    @click="openConfirmSubmitDialog"
                    :disabled="isSubmitting"
                  >
                    {{ isSubmitting ? "กำลังส่งข้อมูล..." : "ส่งข้อมูล" }}
                  </v-btn>
                </div>
              </v-form>
            </div>
          </template>
          <v-responsive  v-if="!isLoading && isSubmit && !isSubmitting">
            <v-row>
              <v-col cols="12">
                <v-alert border="left" outlined>
                  ท่านได้ส่งข้อมูลแล้ว หรือ ลิงก์ไม่ถูกต้อง
                  <!--หรือ หมดอายุ-->
                  หากต้องการแก้ไขข้อมูล กรุณาติดต่อเจ้าหน้าที่
                </v-alert>
              </v-col>
            </v-row>
          </v-responsive>
        </v-container>
      </v-card>
    </v-main>
    <v-dialog v-model="isConfirmDialog" width="290">
      <v-card>
        <v-card-title class="tw-block"> ส่งข้อมูลที่กรอก?</v-card-title>
        <v-card-actions>
          <v-btn text @click="isConfirmDialog = false"> ไม่</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="handleSubmitData()"
          >
            ใช่
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="submitSuccess" color="success" timeout="5000" top>
      ส่งข้อมูลเรียบร้อยแล้ว
    </v-snackbar>
  </v-app>
</template>

<script>
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import fc from "@/firebaseConfig";
import formatTwoDecimal from "@/libs/formatTwoDecimal";



export default {
  components: { ThailandAutoComplete },
  data() {
    return {
      isConfirmDialog: false,
      isLoading: true,
      isSubmitting: false,
      customerData: {
        name: "",
        taxId: "",
        address: {
          address1: "",
          address2: "",
          block: "",
          city: "",
          county: "",
          zipCode: "",
        },
      },
      isAddressValid: true,
      linkId: "",
      invoiceInfo: {},
      isSubmit: false,
      submitSuccess: false,
    };
  },
  methods: {
    formatTwoDecimal,
    select(address) {
      this.customerData.address.block = address.district;
      this.customerData.address.city = address.amphoe;
      this.customerData.address.county = address.province;
      this.customerData.address.zipCode = address.zipcode;
    },
    openConfirmSubmitDialog() {
      this.isConfirmDialog = true;
    },
    handleSubmitData() {
      this.isConfirmDialog = false;
      const isValid = this.$refs.taxForm.validate();
      this.isAddressValid =
        this.customerData.address.block !== "" &&
        this.customerData.address.city !== "" &&
        this.customerData.address.county !== "" &&
        this.customerData.address.zipCode !== "" &&
        this.customerData.address.zipCode >= 10000 &&
        this.customerData.address.zipCode <= 99999;
      if (!this.isAddressValid || !isValid) return;
      
      const API_ENDPOINT = fc.cloudFunctionUrl + "apiSubmitABBTaxInfo";
      // const API_ENDPOINT = "http://127.0.0.1:5001/sld-etax/us-central1/apiSubmitABBTaxInfo";
      console.log("API_ENDPOINT", API_ENDPOINT);
      this.isSubmitting = true;
      fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          linkId: this.linkId,
          data: {
            ...this.customerData.address,
            name: this.customerData.name,
            taxId: this.customerData.taxId,
          },
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            this.submitSuccess = true;
            this.isSubmit = true;
            this.invoiceInfo = {};
          }
        })
        .catch(console.error)
          .finally(() => {
            this.isSubmitting = false;
          });
    },
    async getPendingTaxInvoiceInfo() {
      this.isLoading = true;
      try {
        const ivData = await fc.db
          .doc(`/ABBTaxInfoPending/${this.linkId}`)
          .get();
        if (ivData.exists) {
          this.invoiceInfo = ivData.data();
        }
      } catch (e) {
        if (e.code === "permission-denied") {
          this.isSubmit = true;
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  async created() {
    this.linkId = this.$route.params.linkId;
    if (!this.linkId || this.linkId.length < 4) {
      await this.$router.push("/");
    }
    this.getPendingTaxInvoiceInfo()
      .then(() => {
        if (this.invoiceInfo?.docId) {
          const zipAddressEls = this.$refs.zipAddress.querySelectorAll(
              "input.vth-addr-input[data-v-1f53c317]"
          );
          for (let i = 0; i < zipAddressEls.length - 1; i++) {
            zipAddressEls[i].setAttribute("readonly", true);
          }
        }
      })
      .catch(console.error);
  },
  mounted() {},
};
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}

.s-table {
  width: 100%;

  div {
    padding: 0.5rem 0;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    gap: 1rem;
    justify-content: space-between;

    span {
      flex-basis: 50%;
    }

    @media (max-width: 600px) {
      flex-direction: column;
      span {
        flex-basis: 100%;
      }
      span:last-child {
        text-align: right;
      }
    }
  }

  div:last-child {
    border-bottom: none;
  }
}

#tax-info-form {
  .material-textfield {
    position: relative;

    label {
      position: absolute;
      font-size: 12px;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: white;
      color: rgba(0, 0, 0, 0.6);
      padding: 0 0.3rem;
      margin: 0 0.5rem;
      transition: 0.1s ease-out;
      transform-origin: left top;
      pointer-events: none;
      line-height: 10px;

      &.text-color-error {
        color: #b71c1c !important;
      }
    }

    input {
      border-radius: 4px !important;
      border: 1px solid rgba(0, 0, 0, 0.4) !important;
      //color: rgba(0, 0, 0, 0.6);
      transition: 0.5s ease-out;

      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.87) !important;
      }

      &:focus {
        border: 2px solid #6ec39b !important;
      }

      &.input-error {
        border: 2px solid #b71c1c !important;
      }
    }

    .vth-addr-container:focus-within + label {
      color: #6ec39b;
    }

    input[type="text"] {
      min-height: 56px;
      //padding: 12px 10px;
      line-height: 28px;
    }

    .vth-addr-label {
      padding-left: 0.2rem;
    }
  }

  .vth-addr-input-size-large[data-v-1f53c317] {
    font-size: 16px;
  }

  .vth-addr-input[data-v-1f53c317] {
    border-radius: 10px !important;
    line-height: unset;
    box-shadow: unset;
  }

  .vth-addr-input[data-v-1f53c317][readonly] {
    background-color: #f6f6f6;

    &:hover {
      border: 1px solid rgba(0, 0, 0, 0) !important;
    }

    &:focus {
      border: 2px solid rgba(110, 195, 155, 0) !important;
    }
  }

  *[data-v-1f53c317] {
    font-family: unset;
  }

  .input-address-error {
    font-size: 12px;
    color: #b71c1c;
    line-height: 2px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    margin-left: 13px;
  }

  .btn-user-type-right {
    border: solid 1px #c4c4c4;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    border-left: none;
  }

  .btn-user-type-left {
    border: solid 1px #c4c4c4;
    border-radius: 10px 0 0 10px;
    cursor: pointer;
    border-right: none;
  }

  .otp-input {
    width: 40px;
    height: 44px;
    margin-left: 5px;
    margin-bottom: 30px;
    font-size: 16px;
    border-radius: 10px;
    border: solid 1px #c4c4c4;
    text-align: center;

    &.error {
      background-color: white !important;
      border: 1px solid #b71c1c !important;
      margin-bottom: 0;
    }
  }

  div[is-input-num="true"] div:first-child input {
    margin-left: 0;
  }

  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  fieldset {
    border-radius: 10px;
  }

  .submit-btn-wrapper {
    @media (min-width: 600px) {
      width: 300px;
      margin-inline: auto;
    }
  }

  .btn-form {
    @media (min-width: 600px) {
      width: 100%;
    }
    font-weight: 500;
    border-radius: 10px;
  }
}
</style>
